import { EntityDoc } from "../../entity/EntityDoc";

export class DtoDocsDeleteRes extends EntityDoc {
  public message: string | null = null;
}
